<div id="document-header-content" class="documents-header">
  <section class="documents-header__topbar">
    <div class="documents-header__topbar--content">
      <div class="documents-header__left">
        <button (click)="openSidebar()" class="documents-header__topbar--actionBtn" [disabled]="disableActions">
          <mat-icon class="documents-header__topbar--menuBtn">menu</mat-icon>
          <span class="documents-header__topbar--menuBtnLabel">{{ 'newcircuit_header_acciones' | translate:_transParam
            }}</span>
        </button>
        <p class="progress__label">
          {{ 'signaturit_pro.document.fill_in_2' | translate:_transParam }} {{totalDocuments}} {{fill_in_6}}
        </p>
      </div>
      <div class="documents-header__right">
        <signaturit-button *ngIf="!helperFinishOp" (click)="showHelpModal()" [type]="'secondary'" [size]="'md'"
          [altIcon]="'help'">
        </signaturit-button>
        <signaturit-button *ngIf="totalDocuments > 1" [matMenuTriggerFor]="menu" [text]="documentLabel"
          [type]="'tertiary'" [size]="'md'"></signaturit-button>
        <mat-menu #menu="matMenu" xPosition="before" class="menu document__menu">
          <button mat-menu-item *ngFor="let document of mainDocs; let i = index"
            [class.document__selected]="selectedDocumentId === document.idDocument">
            <p class="document__name clickable"
              [ngStyle]="{ 'font-weight': selectedDocumentId === document.idDocument ? '500' : null }"
              (click)="onDocumentSelect(document)">{{ (document.title) ? document.title : document.fileNameWithExtension
              }}</p>
            <span *ngIf="_finishProService.documentsReaded[i]?.loaded" class="material-icons custom__check"
              [matTooltip]="'document_tooltip_readed' | translate">visibility</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="documents-header__languages" *ngIf="showLanguageSelector | async">
      <app-languages mode="dark" [selectedLang]="_languageService.lang" [forceReload]="false"></app-languages>
    </div>
  </section>
</div>
<aside class="sidebar" [ngClass]="{ sidebarOpen: isSidebarOpen, sidebarClose: !isSidebarOpen }">
  <div class="sidebar__content">
    <signaturit-button text="{{'finish_btn_close' | translate:_transParam }}" type="ghost" size="sm"
      (click)="closeSidebar()">
    </signaturit-button>
  </div>
  <div class="transaction-info">
    {{'signaturit_pro.document.title' | translate:_transParam }}
  </div>
  <nav class="sidebar__navBase">
    <div class="sidebar__navBase--size">
      <div class="text-container">
        <div class="h-5">{{ 'signaturit_pro.document.sender' | translate:_transParam }}</div>
        <div class="p">{{ creatorName }}</div>
      </div>
      <div class="text-container">
        <div class="h-5">{{ 'signaturit_pro.document.contact_email' | translate:_transParam }}</div>
        <div class="tes-tcard">
          <div class="button-text">
            <p class="signerText">{{ creatorEmail }}</p>
          </div>
          <mat-icon class="card-icon" id="copyIcon" (click)="copyClip()">content_copy</mat-icon>
        </div>
      </div>
      <div *ngIf="customMessage" class="text-container">
        <div class="h-5">{{ 'note_form_label_custom_message' | translate:_transParam }}</div>
        <div class="p">{{customMessage}}</div>
      </div>
      <div class="sidebar__navBase--size-container" id="containerHead">
        <p class="sidebar__navBase--size-container-txt">{{ 'finish_documentos' | translate:_transParam }}</p>
        <signaturit-button *ngIf="operationType === 'DWN'"
          text="{{'finish_btn_descargartodos' | translate:_transParam }}" type="auxiliar" size="sm"
          (click)="downloadDocuments(1)">
        </signaturit-button>
      </div>
      <div *ngFor="let doc of documents; let i = index" class="containerDoc" (mouseover)="showKebab(i)"
        (mouseleave)="hideKebab(i)">
        <div class="containerNameDoc">
          {{doc.fileNameWithExtension}}
        </div>
        <signaturit-kebab-menu id="kebab_{{i}}" class="containerDoc--kebab" [kebabMenuOptions]="kebabMenuOptions"
          (clickKebabOption)="onclickKebab($event, i, false)"></signaturit-kebab-menu>
      </div>
    </div>
    <div class="sidebar__navBase--size" *ngIf="hasExtra">
      <div class="sidebar__navBase--size-container">
        <p class="sidebar__navBase--size-container-txt">{{ 'finish_documentos_additional' | translate:_transParam }}</p>
      </div>
      <div *ngFor="let doc of extraDocuments; let i = index" class="containerDoc" (mouseover)="showKebabExtra(i)"
        (mouseleave)="hideKebabExtra(i)">
        <div class="containerNameDoc">
          {{doc.fileNameWithExtension}}
        </div>
        <signaturit-kebab-menu id="kebabExtra_{{i}}" class="containerDoc--kebab" [kebabMenuOptions]="kebabMenuOptions"
          (clickKebabOption)="onclickKebab($event, i, true)"></signaturit-kebab-menu>
      </div>
    </div>
    <div class="sidebar__navBase--size" *ngIf="letAttachment">
      <div>
        <filesupload #secondaryUpload [header]="'client_doc_title' | translate:_transParam" [type]="'secondary'"
          [maxFileSize]="maxFileSize" [docSizeTotal]="docSizeTotal" [maxFiles]="fileConfig.secondaryMax"
          [chooseLabel]="'newcircuit_label_seleccionar' | translate:_transParam" [finish]="true"
          [cancelLabel]="'newcircuit_label_borrar' | translate:_transParam" [accept]="extensions.secondary"
          [multiple]="fileConfig.secondaryMax > 1" [docPrevious]="docsUploadedTitle" (onSelect)="onUploadDoc($event)"
          (onClear)="onClearDoc()" (onRemove)="onRemoveDoc($event)" [lite]="true">
        </filesupload>
      </div>
    </div>
    <div class="sidebar__navBase--size" *ngIf="operationType !== 'DWN'">
      <div class="declineContainer">
        <signaturit-button *ngIf="operationType !== 'VAL'" text="{{'signaturit_pro.document.decline_signa' |
        translate:_transParam }}" type="auxiliar" icon="cancel" size="sm" (click)="closeSign()">
        </signaturit-button>
        <signaturit-button *ngIf="operationType === 'VAL'" text="{{'signaturit_pro.document.decline' |
        translate:_transParam }}" type="auxiliar" icon="cancel" size="sm" (click)="closeSign()">
        </signaturit-button>
      </div>
    </div>
    <div *ngIf="internalMessages" class="sidebar__navBase--size">
      <span class="sidebar__navBase--size-container-txt">{{ 'internal_message_title' | translate:_transParam }}
      </span>
      <div class="messageBtn">
        <signaturit-button icon="chat" type="auxiliar" size="sm" (click)="openDialog()">
        </signaturit-button>
      </div>
      <div class="messageOverflow">
        <ng-container *ngFor="let message of messages">
          <div class="message">
            <div
              *ngIf="message.dateSend && ownerId == message.owner || receiverId == message.owner; then senderMessage; else managerMessage">
            </div>

            <ng-template #senderMessage>
              <div *ngIf="message.dateSend && ownerId == message.owner; then ownerMessage; else receiverMessage">
              </div>

              <ng-template #ownerMessage>
                <p class="responseMessage">
                  {{message.dateSend | date: 'dd-MM-yyyy HH:mm'}} -
                  {{'internal_message_owner' | translate:_transParam }}</p>
              </ng-template>

              <ng-template #receiverMessage>
                <p class="responseMessage">
                  {{message.dateSend}} - {{'internal_message_receiver' | translate:_transParam }}</p>
              </ng-template>
            </ng-template>

            <ng-template #managerMessage>
              <p class="responseMessage">
                {{message.dateSend}} - {{'internal_message_manager' | translate:_transParam }}</p>
            </ng-template>

            <p *ngIf="message.message" class="contentMessage">
              {{message.message}}</p>
          </div>
        </ng-container>
      </div>
    </div>
  </nav>
</aside>
<div (click)="closeSidebar()" [ngClass]="{ aside__open: isSidebarOpen, aside__close: !isSidebarOpen }"></div>
